import type { Config } from "@src/@types/Config";
import apiCaller from "./ApiCaller";
import { startMonitoring } from "./monitoring/sentry";

class ConfigLoader {
  config!: Config;

  // Swift has no first-run setup page (the vendor registration flow was removed), so this is
  // always false and "/" always goes to the dashboard (or the login page when signed out).
  isFirstLaunch = false;

  async load() {
    const res = await apiCaller.get("/api/config");
    this.config = res.data.config;
    // Error monitoring: on only if /api/config has a Sentry DSN (SENTRY_FRONTEND_DSN on the
    // server); never delays the app.
    void startMonitoring(res.data.config?.sentry);
  }
}

export default new ConfigLoader();
